import { useEffect } from 'react';
import { syncOfflineQueue } from '../lib/offlineSync';
import { useOnlineStatus } from './useOnlineStatus';

export function useOfflineQueueSync() {
  const isOnline = useOnlineStatus();

  useEffect(() => {
    if (!isOnline) return;

    syncOfflineQueue();
    window.addEventListener('online', syncOfflineQueue);

    return () => {
      window.removeEventListener('online', syncOfflineQueue);
    };
  }, [isOnline]);
}
